export default "__VITE_ASSET__rSlfEnww__"